import React from 'react';
import { motion } from 'framer-motion';
import { ShieldIcon, LockIcon, DownloadIcon, FileTextIcon, MailIcon } from 'lucide-react';
import { CTAButton } from './Shared';
import { PACK_IMAGE, PRODUCT_NAME, PRICE, BRAND_NAME } from '../data/pack';
const trustItems = [{
  icon: ShieldIcon,
  label: '7-Day Guarantee'
}, {
  icon: LockIcon,
  label: 'Secure Payment'
}, {
  icon: DownloadIcon,
  label: 'Instant Download'
}, {
  icon: FileTextIcon,
  label: '100% Digital PDF'
}, {
  icon: MailIcon,
  label: 'Immediate Email Access'
}];
export const Hero = () => {
  return <header className="relative flex min-h-[calc(100svh-40px)] flex-col justify-center overflow-hidden pb-6 pt-4 md:min-h-[calc(100svh-48px)] md:pb-10 md:pt-8" data-id="element-99" data-mp="sbb0xbqjc4b7">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden" data-id="element-100" data-mp="nbonb16som1v">
        <div className="absolute left-[6%] top-[24%] hidden h-64 w-64 rounded-full border border-brand-goldDark/10 md:block" data-id="element-101" data-mp="3czfoc8080na9" />
        <div className="absolute bottom-[6%] right-[7%] hidden h-48 w-48 rounded-full border border-brand-goldDark/10 md:block" data-id="element-102" data-mp="3j8sfs1yzrlqd" />
      </div>

      <div className="relative z-10 mx-auto w-full max-w-5xl px-4 text-center sm:px-6 lg:px-8" data-id="element-103" data-mp="3o6amdlpjdov7">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="flex flex-col items-center" data-id="element-104" data-mp="399jnddjryf64">
          <span className="font-display text-[9px] font-semibold uppercase tracking-[0.42em] text-brand-goldDark md:text-[11px]" data-id="element-105" data-mp="30fybc1yzvc0e">
            {BRAND_NAME}
          </span>
          <span aria-hidden="true" className="ink-rule mt-2 w-14 md:w-20" data-id="element-106" data-mp="2qlep2llvzmep" />

          <h1 className="mt-3.5 max-w-[21ch] font-display text-[29px] font-semibold leading-[1.08] tracking-[0.005em] text-brand-burgundy sm:max-w-[24ch] sm:text-[44px] md:mt-4 md:text-[54px] lg:text-[60px]" data-id="element-107" data-mp="2vi50uwqnrvub">
            Stop Planning Every Qigong Class{' '}
            <span className="relative inline-block" data-id="element-108" data-mp="s21hi9lxc9yx">
              <span aria-hidden="true" className="absolute inset-x-[-6px] bottom-[0.08em] h-[0.3em] bg-brand-goldLight/55" data-id="element-109" data-mp="s2td3kfiu7p7" />
              <span className="relative" data-id="element-110" data-mp="ibp02q9eowx0">From Scratch</span>
            </span>
          </h1>

          <p className="mt-2.5 max-w-[42ch] font-display text-[12.5px] font-normal leading-[1.4] text-brand-textLight/90 sm:max-w-[52ch] md:mt-3.5 md:text-[17px] md:leading-[1.45]" data-id="element-111" data-mp="ddnhs7jt11ml">
            Access a complete visual system to structure, adapt and lead your
            practices with greater confidence.
          </p>

          <div className="relative mt-3 w-full max-w-[470px] md:mt-5 md:max-w-2xl lg:max-w-[680px]" data-id="element-112" data-mp="111om149y9vw7">
            <div aria-hidden="true" className="absolute left-1/2 top-1/2 -z-10 h-[70%] w-[70%] -translate-x-1/2 -translate-y-1/2 rounded-full border border-brand-goldDark/20" data-id="element-113" data-mp="x032j02wujd1" />
            <motion.img src={PACK_IMAGE.src} alt={PACK_IMAGE.alt} initial={{
            opacity: 0,
            scale: 0.97
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.55,
            ease: [0.23, 1, 0.32, 1]
          }} className="mx-auto max-h-[46svh] w-full object-contain md:max-h-[52svh]" draggable={false} decoding="async" data-id="element-114" data-mp="3hpsff7k1zv33" />
          </div>

          <div className="mt-3.5 flex flex-col items-center gap-2.5 md:mt-5 md:gap-4" data-id="element-115" data-mp="2g02k2hzehjyc">
            <CTAButton className="h-[56px] w-[239px] px-3 py-0 text-center text-[11px] leading-[1.3] tracking-[0.12em]" data-id="element-116" data-mp="2kyvolkwpm0md">
              Get the Complete Bundle — {PRICE}
            </CTAButton>

            <ul className="grid w-full max-w-[340px] grid-cols-6 gap-x-2 gap-y-1.5 font-sans text-[10.5px] text-brand-muted sm:max-w-none sm:grid-cols-5 sm:gap-x-5 md:gap-x-6 md:text-sm" data-id="element-117" data-mp="2oyo1uax1suy2">
              {trustItems.map(({
              icon: Icon,
              label
            }, i) => <li key={label} className={`flex items-center justify-center gap-1 ${i < 3 ? 'col-span-2' : 'col-span-3'} sm:col-span-1`} data-id="element-118" data-mp="zmc3ibr3h37t" data-mpi={i}>
                  <Icon className="h-3 w-3 shrink-0 text-brand-goldDark md:h-4 md:w-4" data-id="element-119" data-mp="3vjrre5zkhlpf" />
                  <span className="text-center leading-tight" data-id="element-120" data-mp="e8sd9fg4cygx">{label}</span>
                </li>)}
            </ul>
          </div>
        </motion.div>
      </div>

      <div className="relative z-10 mx-auto mt-8 max-w-3xl px-4 text-center sm:px-6 md:mt-10" data-id="element-121" data-mp="3hr2663rv4ktd">
        <h2 className="font-display text-[15px] font-bold uppercase tracking-[0.16em] text-brand-burgundy md:text-2xl" data-id="element-122" data-mp="3cs8tueobazus">
          {PRODUCT_NAME}
        </h2>
        <p className="mx-auto mt-2.5 max-w-2xl font-display text-[13px] font-normal leading-[1.55] text-brand-textLight/85 md:text-base" data-id="element-123" data-mp="3mpdgsgpzezcn">
          3 professional volumes + 5 practical bonuses for instructors,
          therapists and experienced practitioners who want to take their Qigong
          practice to the next level.
        </p>
      </div>
    </header>;
};